import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getIncidentes} from "../api";

const FilterTableIncidenteVer = () => {
  const [Incidente, setIncidente] = useState([]);
  const [filteredIncidente, setFilteredIncidente] = useState([]);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchIncidente = async () => {
    try {
      const response = await getIncidentes();
      setIncidente(response.data);
      setFilteredIncidente(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching incidente:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchIncidente();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = Incidente.filter((Incidente) =>
        Incidente.id.toString().includes(filterText.toLowerCase()) ||
        Incidente.nota.toLowerCase().includes(filterText.toLowerCase()) ||
        Incidente.empleado.toLowerCase().includes(filterText.toLowerCase()) ||
        Incidente.id_tipo_incidente.toLowerCase().includes(filterText.toLowerCase()) 
      );
      setFilteredIncidente(filtered);
    } else {
      setFilteredIncidente(Incidente);
    }
  }, [filterText, Incidente]);

  return (
    <div>
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por id, descripción, tipo_incidente o usuario..."
          className="input3"
        />
      </div>
      {filteredIncidente.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th>tipo_incidente</th>
              <th>Personal</th>
              <th>Fecha</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {filteredIncidente.map((Incidente) => (
              <tr key={Incidente.id}>
                <td>{Incidente.id}</td>
                <td>{Incidente.nota}</td>
                <td>{Incidente.tipo_incidente}</td>
                <td>{Incidente.id_empleado}</td>
                <td>{Incidente.fecha_incidente}</td>
                <td>{Incidente.estado}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableIncidenteVer.propTypes = {
  incidente: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nota: PropTypes.string,
    })
  ),
};

export default FilterTableIncidenteVer;